import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Building2, LogOut, Wifi, KeyRound, ChevronDown } from "lucide-react";
import RemindersBell from "@/components/RemindersBell";

const ROLE_LABEL = {
  executive: "Sales Executive",
  sales_manager: "Sales Manager",
  management: "Management Admin",
};

export default function TopNav({ synced }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-30 bg-white border-b border-slate-200">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="h-9 w-9 rounded-lg bg-[#1E3A8A] flex items-center justify-center text-white">
            <Building2 className="h-5 w-5" />
          </div>
          <div className="leading-none">
            <p className="font-heading font-bold text-slate-900">Tamanna Sales Hub</p>
            <p className="text-xs text-slate-400 mt-1 hidden sm:block">Lead Management Portal</p>
          </div>
        </div>

        <div className="flex items-center gap-3 sm:gap-4">
          <div
            className="hidden sm:flex items-center gap-1.5 text-xs text-emerald-600"
            data-testid="polling-indicator"
            title="Auto-refresh active"
          >
            <span className="h-2 w-2 rounded-full bg-emerald-500 pulse-dot" />
            <Wifi className="h-3.5 w-3.5" />
            <span>{synced ? `Synced ${synced}` : "Live"}</span>
          </div>

          <div className="text-right leading-none" data-testid="current-user">
            <p className="text-sm font-semibold text-slate-900">{user.name}</p>
            <p className="text-xs text-[#1E3A8A] font-medium mt-1">{ROLE_LABEL[user.role]}</p>
          </div>

          <RemindersBell />

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="outline" size="sm" data-testid="account-menu-button" className="gap-1">
                Account
                <ChevronDown className="h-3.5 w-3.5" />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-48">
              <DropdownMenuItem onClick={() => navigate("/change-password")} data-testid="menu-change-password">
                <KeyRound className="h-4 w-4 mr-2" /> Change password
              </DropdownMenuItem>
              <DropdownMenuItem onClick={logout} data-testid="logout-button" className="text-rose-600 focus:text-rose-600">
                <LogOut className="h-4 w-4 mr-2" /> Logout
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
}
